import { Component, NgZone, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { ListCompanies } from '../models/company.model';
import { CompanyService } from '../services/company.service';
import { WorkerService } from '../services/worker.service';
import { LanguageService } from '../services/language.service';
import { MenusComponent } from '../menus/menus.component';
import { DialogService } from '../services/dialog.service';
import { TranslocoService } from '@jsverse/transloco';
import { WorkerElement } from '../models/worker.model';
import { AlarmConfigurationFunctionMode } from '../alarm-configuration/alarm-configuration.component';
import { StorageService } from '../services/storage.service';

@Component({
  selector: 'app-worker',
  templateUrl: './worker.component.html',
  styleUrl: './worker.component.css'
})

export class WorkerComponent implements OnInit {

  constructor(public ngZone: NgZone, private router: Router, private route: ActivatedRoute,
              private companyService: CompanyService, private workerService: WorkerService,
              private menusComponent: MenusComponent, private dialogService: DialogService,
              private langService: LanguageService, private translocoService: TranslocoService,
              public storageService: StorageService) { }

  public titleWorker = "Trabajador";
  public new = false;
  id: number=0;
  companyId: number=0;
  rolControl = new FormControl('', [Validators.required]);
  companyControl = new FormControl('', [Validators.required]);

  lstCompanies: ListCompanies[] = [];
  item: any = [];

  first_name_Input:string="";
  last_name_Input:string="";
  dni_Input:string="";
  company_Selected:number=0;

  worker: WorkerElement = {
    id: 0,
    first_name: '',
    last_name: '',
    dni: '',
    company_id: 0,
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.id = (params['id']);
      this.companyId = (params['companyId']);
    });

    if(this.id > 0 && this.companyId > 0){
      this.new = false;
      this.translocoService.selectTranslate('worker.titleEdit')
        .subscribe((translatedTitle: string) => { this.titleWorker = translatedTitle; });

      this.workerService.getWorkerById(this.id, this.companyId).subscribe({
        next: (res) => {
          this.item = res;
          if(this.item.data != null){
            this.first_name_Input  = this.item.data.first_name;
            this.last_name_Input   = this.item.data.last_name;
            this.company_Selected  = this.item.data.company_id;
            this.dni_Input         = this.item.data.dni;
          }
        },
        error: (e) => { console.error(e); },
      });

    } else {
      this.new = true;
      this.company_Selected = this.storageService.companyId;
      this.companyId = this.storageService.companyId;
      this.translocoService.selectTranslate('worker.titleNew')
        .subscribe((translatedTitle: string) => { this.titleWorker = translatedTitle; });
    }

    this.lstCompanies = this.companyService.getCompaniesListByRol(this.storageService.roleId, this.companyId);
  }

  onGuardarItm(){
    if ( !(this.company_Selected>0) ) { return; }
    let msg:string="";
    if (this.new){
      this.worker = {
        id: 0,
        first_name: this.first_name_Input,
        last_name: this.last_name_Input,
        dni: this.dni_Input,
        company_id: this.company_Selected,
      };
      this.workerService.addWorker(this.worker, this.companyId).subscribe({
        next: (res) => { msg = res.message; console.log(msg); this.msgDialog(msg, '', true, 'O'); },
        error: (e) => { msg = e.error.message; console.error(e); this.msgDialog('ERROR', msg, false, 'E'); },
      });
    } else {
      this.worker = {
        id: this.id,
        first_name: this.first_name_Input,
        last_name: this.last_name_Input,
        dni: this.dni_Input,
        company_id: this.company_Selected,
      };
      this.workerService.updateWorker(this.id, this.worker, this.companyId).subscribe({
        next: (res) => { msg = res.message; console.log(msg); this.msgDialog(msg, '', true, 'O'); },
        error: (e) => { msg = e.error.message; console.error(e); this.msgDialog('ERROR', msg, false, 'E'); },
      });
    }
  }

  msgDialog(msgShow:string, msg2Show:string, isOK:boolean, type:string){
    this.dialogService.confirmDialog({
      title: 'Trabajador',
      message: msgShow,
      message2: msg2Show,
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: type,
    }).subscribe((yes) => {
      if (isOK) { setTimeout(() => { this.router.navigate(['workers']); }, 1000); }
    });
  }

  EliminarItm(){
    let msg:string="";
    this.workerService.deleteWorker(this.id, this.companyId).subscribe({
      next: (res) => { msg = res.message; console.log(msg); this.msgDialog(msg, '', true, 'O'); },
      error: (e) => { msg = e.error.message; console.error(e); this.msgDialog('ERROR', msg, false, 'E'); },
    });
  }

  onEliminarItm() {
    this.dialogService.confirmDialog({
      title: this.translocoService.translate('worker.msgTitle'),
      message: this.translocoService.translate('worker.msgMessage'),
      message2: this.translocoService.translate('worker.msgMessage2'),
      confirmText: this.translocoService.translate('worker.confirmText'),
      cancelText: this.translocoService.translate('worker.cancelText'),
      showConfirmBox: true,
      dialogType: 'A',
    }).subscribe((yes) => {
      if (yes) { this.EliminarItm(); console.log('Si Eliminar.'); }
    });
  }

  onAlarmConfigItm(){
    this.dialogService.openAlarmConfiguration(AlarmConfigurationFunctionMode.WORKER, this.id.toString());
  }
}
